import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  @Input() headerMsg: string = "Warning!";
  @Input() bodyMsg: string = "Are you sure?";
  @Input() primaryButtonText: string = "Yes";
  @Input() secondaryButtonText: string = "Cancel";
  @Input() fn: Function;

  ngOnInit() {
  }

  ok() {
    this.fn();
  }

  cancel() {
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/confirmation-modal/confirmation-modal.component.ts